import {
    ORDER_SUCCESS,
    ORDER_LOADING,
    TABLE_LOADING
} from '../actions/OrderAction';

const initialState = {
    amazon: {
        orderData: null,
        isLoading: true,
        isTableLoading: true
    },
    shopify: {
        orderData: null,
        isLoading: true,
        isTableLoading: true
    },
    wholesale: {
        orderData: null,
        isLoading: true,
        isTableLoading: true
    }
};

const OrderReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ORDER_SUCCESS:
            return {
                ...state, [action?.vendor]: { orderData: action.data, isLoading: false, isTableLoading: false }
            };
        case ORDER_LOADING:
            return { ...state, [action?.vendor]: { ...state?.[action?.vendor], isLoading: action.isLoading } };
        case TABLE_LOADING:
            return {
                ...state, [action?.vendor]: {
                    ...state?.[action?.vendor],
                    isTableLoading: action.isTableLoading
                }
            };

        default:
            return state;
    }
};

export default OrderReducer;